var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteriorFinishing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7451 19.6984L54.3851 24.0584C53.0251 25.4184 53.0251 27.6284 54.3851 28.9984L76.4451 51.0584C77.8051 52.4184 80.0151 52.4184 81.3851 51.0584L82.5051 49.9384L82.8451 50.2784C83.4151 50.8484 83.4151 51.7884 82.8451 52.3584L77.9752 57.2284C77.1952 58.0084 76.0152 58.2784 74.9651 57.8984L57.2951 51.5584C55.4851 50.9084 53.4351 51.3684 52.0651 52.7284L46.3751 58.4184L46.1551 58.1984C44.9851 57.0284 43.0951 57.0284 41.9251 58.1984L23.3251 76.7984C22.1551 77.9684 22.1551 79.8584 23.3251 81.0284L25.3351 83.0384C26.5051 84.2084 28.3951 84.2084 29.5651 83.0384L48.1651 64.4384C49.3351 63.2684 49.3351 61.3784 48.1651 60.2084L47.9451 59.9884L53.6351 54.2984C54.3851 53.5484 55.5251 53.2884 56.5251 53.6484L74.1951 59.9884C76.0451 60.6584 78.1451 60.1884 79.5351 58.7884L84.4052 53.9184C85.8551 52.4684 85.8551 50.1184 84.4052 48.6784L84.0651 48.3384L85.7151 46.6884C87.0751 45.3284 87.0751 43.1184 85.7151 41.7484L63.6551 19.6884C62.2951 18.3284 60.0851 18.3284 58.7151 19.6884L58.7451 19.6984ZM28.3351 80.3984C27.6851 81.0484 26.6151 81.0484 25.9651 80.3984C25.3151 79.7484 25.3151 78.6784 25.9651 78.0284C26.6151 77.3784 27.6851 77.3784 28.3351 78.0284C28.9851 78.6784 28.9851 79.7484 28.3351 80.3984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1251 47.7984L31.9151 44.0084C32.0451 43.8784 32.0551 43.6784 31.9451 43.5384L30.3551 41.4584C30.0951 41.1184 30.5451 40.6884 30.8751 40.9584L32.8651 42.5984C33.0051 42.7184 33.2151 42.7084 33.3551 42.5784L41.3851 34.5484C41.5151 34.4184 41.5251 34.2084 41.4151 34.0684L39.7751 32.0484C39.5151 31.7184 39.9251 31.2784 40.2651 31.5284L42.4451 33.0784C42.5851 33.1784 42.7851 33.1684 42.9051 33.0384L45.6351 30.3084C45.7651 30.1784 45.7751 29.9684 45.6651 29.8284L35.3251 16.7384C35.1951 16.5684 34.9352 16.5584 34.7851 16.7084L32.0751 19.4184C31.9451 19.5484 31.9351 19.7484 32.0451 19.8984L34.9751 23.6784C35.2351 24.0084 34.8151 24.4384 34.4751 24.1884C33.0551 23.1384 31.3351 21.7884 30.6951 21.2784C30.5551 21.1684 30.3451 21.1784 30.2151 21.3084L25.5551 26.0584C25.4451 26.1684 25.4151 26.3484 25.4951 26.4884L26.4551 28.2084C26.6351 28.5384 26.2551 28.8984 25.9351 28.6884L24.4851 27.7284C24.3451 27.6284 24.1551 27.6484 24.0251 27.7784L14.8351 36.9684C14.6851 37.1184 14.6951 37.3684 14.8651 37.5084L27.6451 47.8484C27.7851 47.9684 27.9951 47.9584 28.1251 47.8184V47.7984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7151 39.2484C54.5651 38.6284 53.9651 38.2284 53.4551 37.9884L35.9151 55.5284C36.1651 56.0284 36.5551 56.6284 37.1751 56.7884C38.4751 57.1084 39.3851 55.1684 41.2051 54.3284C43.5951 53.2084 46.4751 54.4784 48.0651 55.3084L51.3651 52.0084C51.9851 51.3884 52.7151 50.9284 53.5051 50.6384C52.7451 49.2284 51.0151 45.9584 52.2551 43.2784C53.1051 41.4584 55.0351 40.5384 54.7151 39.2484Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2751 74.9784C76.0551 68.1384 68.7251 62.9884 60.6851 57.4684C59.4251 56.6184 58.2251 55.8284 57.1151 54.9184L56.2051 54.5884C55.5651 54.3584 54.8351 54.5184 54.3551 54.9984L51.5851 57.7684C53.0751 59.2284 54.1551 60.9284 55.4051 62.7484C60.9251 70.7884 66.0651 78.1284 72.9151 79.3384C73.4051 79.4284 73.8551 79.4984 74.2751 79.5484C76.1351 79.7784 77.7051 78.1984 77.4851 76.3484C77.4351 75.9284 77.3551 75.4784 77.2751 74.9784ZM74.3351 76.6184C73.7751 77.0884 72.9451 77.1184 72.3551 76.6984C71.4352 76.0384 71.4352 74.6884 72.3652 74.0284C72.9551 73.6084 73.7751 73.6484 74.3351 74.1084C75.1251 74.7684 75.1251 75.9684 74.3351 76.6184Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2751 50.4984C31.0951 50.6784 31.0951 50.9784 31.2751 51.1584L34.5851 54.4684C34.7651 54.6484 35.0651 54.6484 35.2451 54.4684L52.4051 37.3084C52.5851 37.1284 52.5851 36.8284 52.4051 36.6484L49.0951 33.3384C48.9151 33.1584 48.6151 33.1584 48.4351 33.3384L31.2751 50.4984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2751 48.4984C29.0951 48.6784 29.0951 48.9784 29.2751 49.1584L29.7451 49.6284C29.9251 49.8084 30.2251 49.8084 30.4051 49.6284L47.5651 32.4684C47.7451 32.2884 47.7451 31.9884 47.5651 31.8084L47.0951 31.3384C46.9151 31.1584 46.6151 31.1584 46.4351 31.3384L29.2751 48.4984Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1687",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1687",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1687"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1687",
    result: "effect3_innerShadow_4857_1687"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorFinishing);
export default __webpack_public_path__ + "static/media/InteriorFinishing.1fb2eb1466ab54d487f9c34a4aeae159.svg";
export { ForwardRef as ReactComponent };